import * as React from "react";
import { createContext, useState } from "react";
import { UserI } from "../types";

export type GlobalContextObj = {
    loggedUser: UserI | undefined;

    setLoggedUserFn: (user: UserI | undefined) => void;
};

export const GlobalContext = createContext<GlobalContextObj>({
    loggedUser: undefined,

    setLoggedUserFn: (user: UserI | undefined) => {},
});

export const GlobalContextProvider: React.FC<{ children: React.ReactNode }> = (
    props
) => {
    const [loggedUser, setLoggedUser] = useState<UserI | undefined>(undefined);

    const loggedUserHandler = (user: UserI | undefined) => {
        setLoggedUser(user);
    };

    const contextValue: GlobalContextObj = {
        loggedUser: loggedUser,

        setLoggedUserFn: loggedUserHandler,
    };

    return (
        <GlobalContext.Provider value={contextValue}>
            {props.children}
        </GlobalContext.Provider>
    );
};
